import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Facebook, Instagram } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_igbodu-agri/artifacts/swcybtk6_WhatsApp%20Image%202026-03-03%20at%2012.01.34%20PM.jpeg";

// TikTok icon component
const TikTokIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-stone-900 text-stone-300" data-testid="footer">
      <div className="container-custom section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center gap-3">
              <img 
                src={LOGO_URL} 
                alt="AfriGrow Farm Logo" 
                className="h-16 w-16 rounded-full object-cover"
              />
            </Link>
            <p className="text-stone-400 leading-relaxed">
              AfriGrow Farm is dedicated to sustainable agriculture and livestock production in Nigeria. Quality produce, ethical farming.
            </p>
            <div className="flex gap-4">
              <a href="https://web.facebook.com/profile.php?id=61555781956443" target="_blank" rel="noopener noreferrer" className="p-2 bg-stone-800 rounded-full hover:bg-green-600 transition-colors" data-testid="social-facebook">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="https://www.tiktok.com/@afrigrowfarm" target="_blank" rel="noopener noreferrer" className="p-2 bg-stone-800 rounded-full hover:bg-green-600 transition-colors" data-testid="social-tiktok">
                <TikTokIcon className="h-5 w-5" />
              </a>
              <a href="https://www.instagram.com/afri_grow_farm" target="_blank" rel="noopener noreferrer" className="p-2 bg-stone-800 rounded-full hover:bg-green-600 transition-colors" data-testid="social-instagram">
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-semibold text-white mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {["Home", "About", "Services", "Products", "Gallery", "Blog", "Contact"].map((link) => (
                <li key={link}>
                  <Link 
                    to={link === "Home" ? "/" : `/${link.toLowerCase()}`}
                    className="text-stone-400 hover:text-green-400 transition-colors"
                    data-testid={`footer-link-${link.toLowerCase()}`}
                  >
                    {link}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading text-lg font-semibold text-white mb-6">Our Services</h4>
            <ul className="space-y-3">
              {["Pig Farming", "Fish Farming", "Grasscutter Farming", "Vegetable Production", "Palm Cultivation"].map((service) => (
                <li key={service}>
                  <Link 
                    to="/services"
                    className="text-stone-400 hover:text-green-400 transition-colors"
                  >
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading text-lg font-semibold text-white mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-green-500 mt-1 flex-shrink-0" />
                <span className="text-stone-400">Igbodu Epe, Lagos State, Nigeria<br/>Plus Code: JWX7+J8</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-5 w-5 text-green-500 flex-shrink-0" />
                <a href="tel:+2348026994903" className="text-stone-400 hover:text-green-400 transition-colors">
                  +234 802 699 4903
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-green-500 flex-shrink-0" />
                <a href="mailto:info@afrigrowfarm.com" className="text-stone-400 hover:text-green-400 transition-colors">
                  info@afrigrowfarm.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="h-5 w-5 text-green-500 mt-1 flex-shrink-0" />
                <span className="text-stone-400">Mon - Sat: 8:00 AM - 5:00 PM<br/>Sunday: Closed</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-stone-800">
        <div className="container-custom py-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-stone-500 text-sm">
            © {currentYear} AfriGrow Farm. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm">
            <a href="#" className="text-stone-500 hover:text-stone-300 transition-colors">Privacy Policy</a>
            <a href="#" className="text-stone-500 hover:text-stone-300 transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
